import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  modalRef = inject(MdbModalRef<ConfirmModalComponent>);

  // Dati passati alla modale - vengono inizializzati automaticamente da MDB quando si passa data nell'open()
  title: string = '';
  message: string = '';
  yesText: string = 'Sì';
  noText: string = 'No';

  /**
   * Conferma l'azione e chiude la modale restituendo true
   */
  confirm(): void {
    this.modalRef.close(true);
  }

  /**
   * Annulla l'azione e chiude la modale restituendo false
   */
  cancel(): void {
    this.modalRef.close(false);
  }
}

